/* eslint-disable max-statements */
import { FilterMatchMode } from 'primereact/api';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { Column } from 'primereact/column';
import { DataTable, DataTableFilterMeta } from 'primereact/datatable';
import { InputText } from 'primereact/inputtext';
import { toast } from 'react-toastify';
import React, { useEffect, useState } from 'react';
import { Dropdown } from 'primereact/dropdown';
import {
    useCreateScorecardAssignMutation,
    useDeleteScoreCardAssignOverridesMutation,
    useGetScoreCardAssignOverridesQuery,
    useGetScoreCardOverrideTypesQuery,
    useGetScoreCardsQuery
} from '../../../features/edsDashboard/edsExceptionScorecardAssignment/edsExceptionScorecardAssignmentSlice';
import { IDeleteException, IScorecardAssign } from '../../../utils/types';
import './edsExceptionScorecardAssignment.scss';
import { DateTemplate } from '../../../components/dateTemplate/DateTemplate';


export const EdsExceptionTabScoreCardAssignments = (props: any) => {

    const [CreateScoreCardAssign] = useCreateScorecardAssignMutation();
    const today = new Date();
    const month = today.getMonth();
    const year = today.getFullYear();

    const [newStartDate, setNewStartDate] = useState(new Date(year, month, 1));
    const [scoreCardAssignOverrides, setScoreCardAssignOverrides] = useState<any>();
    const curMaxDate = new Date(year, month + 1, 0);
    const curMinDate = new Date(year, month - 8, 1);
    const [scoreCardOverride, setScoreCardOverride] = useState<any>([]);
    const { data: scoreCardOverrideTypes } = useGetScoreCardOverrideTypesQuery({});
    const [DeleteScoreCardAssignOverridesException] = useDeleteScoreCardAssignOverridesMutation();
    const [newScoreCard, setNewScoreCard] = useState<any>([]);
    const [oldScorecard,setOldScorecard] = useState(0);
    const { data: scoreCardsData } = useGetScoreCardsQuery({});
    
    const [selectedScorecards, setSelectedScoreCards] = useState<any>(null);
    const [expirationDate, setExpirationDate] = useState(new Date(year, month + 1, 0));
    const { data: scoreCardAssignOverridesData } = useGetScoreCardAssignOverridesQuery(
        {
            employeenumber: props.agentNumber,
            scorecardId: oldScorecard,
        },
        { skip: !props.agentNumber }
    );
    useEffect(() => {
        if(props.scorecardId !== '' && props.scorecardId !== undefined && props.scorecardId !== null){
            setOldScorecard(Number(props.scorecardId));}
        else{
            setOldScorecard(0);}
        },[props.scorecardId]);
        
    const createScorecardAssign = (startassigndate: any) => {
        CreateScoreCardAssign(startassigndate)
            .unwrap()
            .then((response:any) => {
                if(response.data === 'Record Already Exists')
                { toast.error(response.data);}
                else if (response.data === 'Successfully Inserted') 
                { toast.success("Scorecard Assignment Successful");}
            })
            .then((error: any) => {
                if (error) {
                    toast.error('Scorecard Assignment failed');
                }
            });
    };

    useEffect(() => {
        setScoreCardAssignOverrides([]);
        if (scoreCardAssignOverridesData?.data.length >= 0) {
            const scoreCardAssignOverridesDataWithId: any = [];
            scoreCardAssignOverridesData.data?.map((data:any, index: any) => {
                const newObjWithId = {...data, id: index}
                scoreCardAssignOverridesDataWithId?.push(newObjWithId);
                return '';
            })
            setScoreCardAssignOverrides(scoreCardAssignOverridesDataWithId);
        }
        
    }, [scoreCardAssignOverridesData, newScoreCard]);

    const NewStartDateOnChange = (e: any) => {
        setNewStartDate(e.value);
    };

    const ExpirationDateOnChange = (e: any) => {
        setExpirationDate(e.value);
    };
    const submitProjectAssignOverride = () => {
        if (
            props.agentNumber === undefined ||
            props.agentNumber == null ||
            props.agentNumber === '' 
        ) {
            toast.error('Select a Valid Associate from Associate Lookup. ');
            return;
        }
        if(newStartDate.getMonth() !== expirationDate.getMonth() || newStartDate.getFullYear() !== expirationDate.getFullYear()){
            toast.error('Start and Expiration Dates should be within the same Month-Year.');
            return;
        }
        if((newStartDate.getMonth()+1 !== props.inputMonth && expirationDate.getMonth()+1 !== props.inputMonth) || newStartDate.getFullYear() !== props.inputYear && expirationDate.getFullYear() !== props.inputYear){
            toast.error('Start and Expiration Dates should be within the same Month-Year.');
            return;
        }
         const startassigndate: IScorecardAssign = {
            employeenumber: Number(props.agentNumber),
            createby: props.loggedEmpNum,
            scorecardid: newScoreCard,
            scorecardroleid: props.scoreCardRoleIdValue,
            originalscorecardid: oldScorecard,
            scorecardassignoverridetypeid: scoreCardOverride,
            startoverridedate: newStartDate.toDateString(),
            endoverridedate: expirationDate.toDateString(),
            status: true,
        };
        if (isValidScorecardAssign(startassigndate)) {
            createScorecardAssign(startassigndate);
        } else {
            toast.error('Invalid scorecardAssign data. Please check the data before sending. ');
        }
    }
    const isValidScorecardAssign = (data: IScorecardAssign): boolean => {
        // Perform data validation here based on your specific constraints
        if (
            typeof data.employeenumber !== 'number' ||
            typeof data.scorecardassignoverridetypeid !== 'number' ||
            typeof data.createby !== 'string' ||
            typeof data.scorecardroleid !== 'number' ||
            typeof data.scorecardid !== 'number' ||
            !(data.startoverridedate) ||
            !(data.endoverridedate) ||
            typeof data.status !== 'boolean'
        ) {
            return false;
        }

        // Additional validation logic based on your specific requirements
        // For example, you can check for specific date ranges, string length, etc.

        return true;
    };
    useEffect(() => {
        if (scoreCardsData?.data.length > 0) {
            setNewScoreCard(scoreCardsData?.data);
            // if (window.localStorage.ScFilDdlClient)
            //     setSelectedClient(parseInt(window.localStorage.ScFilDdlClient, 10));
        }
    }, [scoreCardsData]);
    useEffect(() => {
        if (scoreCardOverrideTypes?.data.length > 0) {
            setScoreCardOverride(scoreCardOverrideTypes?.data);
        }
    }, [scoreCardOverrideTypes]);

    const DeleteScorecardException = () => {
        const sCardAssignOverrideIds: any[] = [];
        let oID = '';
        selectedScorecards.forEach((e: any) => {
            oID = e.oracleID;
            sCardAssignOverrideIds.push(e.scorecard_assign_override_id);
        });

        const startdate: IDeleteException = {
            oracleIDs: oID,
            scorecardId: sCardAssignOverrideIds,
        };
        //if (startdate.oracleIDs === undefined || startdate.oracleIDs == null) {
        //handleNoDataClick();
        //} else {
        //}
        DeleteScoreCardAssignOverrides(startdate);
        setSelectedScoreCards(null);
    };
    const DeleteScoreCardAssignOverrides = (startdate: any) => {
        DeleteScoreCardAssignOverridesException(startdate)
            .unwrap()
            .then((response: any) => {
                if (response.status) {
                    toast.success('Deleted Successfully');
                }
            }).catch((error: any) => {
                if (error) console.log(error);
                toast.error('Error while deleting');
            })
    };
    

    const [globalFilterValueScorecard, setGlobalFilterValueScorecard] = useState('');
    const [filters, setFilters] = useState<DataTableFilterMeta>({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    });

    const onGlobalFilterChangeScoreCard = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        const sdfilters = { ...filters };

        // @ts-ignore
        sdfilters.global.value = value;

        setFilters(sdfilters);
        setGlobalFilterValueScorecard(value);
    };

    const renderHeaderScorecard = () => {
        return (
            <div className="d-inline-block justify-content-between w-100">
                <span className="p-input-icon-left mt-4 mt-md-0 d-inline-block">
                    <i className="pi pi-search" />
                    <InputText
                        value={globalFilterValueScorecard}
                        onChange={onGlobalFilterChangeScoreCard}
                        placeholder="Keyword Search "
                    />
                </span>
                <div className="d-inline-block float-start float-md-end">
                    <Button
                        type="button"
                        icon="pi pi-delete"
                        label="Delete"
                        disabled={!selectedScorecards}
                        onClick={DeleteScorecardException}
                        className="btn-primary"
                    />
                </div>
            </div>
        );
    };
    const headerScorecard = renderHeaderScorecard();    

    return (
        < div>
            <div className="row">
                <div className="col-md-12">
                    <div className="card border-0">
                        <div className="card-body border-0">
                            <div className="row mt-2">
                                <div className="col-md-3">
                                    <h6
                                        style={{
                                            fontWeight: '600',
                                            fontSize: '16px',
                                        }}
                                    >
                                        Associate Name
                                    </h6>
                                    <InputText
                                        name="associateName"
                                        value={props.agentName}
                                        disabled

                                        className="borderRadius"
                                    />
                                </div>
                                <div className="col-md-3">
                                    <h6
                                        style={{
                                            fontWeight: '600',
                                            fontSize: '16px',
                                        }}
                                    >
                                        New Start Date
                                    </h6>
                                    <Calendar
                                        id="basic"
                                        value={newStartDate}
                                        onChange={NewStartDateOnChange}
                                        showIcon
                                        className="custom-calendar mb-4"
                                        minDate={curMinDate}
                                        maxDate={curMaxDate}
                                        dateFormat="dd-M-yy"
                                    />
                                </div>
                                <div className="col-md-3 pe-0">
                                    <h6
                                        style={{
                                            fontWeight: '600',
                                            fontSize: '16px',
                                        }}
                                    >
                                        Expiration Date
                                    </h6>
                                    <Calendar
                                        id="basic"
                                        value={expirationDate}
                                        onChange={ExpirationDateOnChange}
                                        showIcon
                                        className="custom-calendar mb-4"
                                        minDate={newStartDate}
                                        maxDate={curMaxDate}
                                        dateFormat="dd-M-yy"
                                    />
                                </div>
                            </div>

                            <div className="row mt-4">
                                <div className="col-md-3">
                                    <h6
                                        style={{
                                            fontWeight: '600',
                                            fontSize: '16px',
                                        }}
                                    >
                                        Current Scorecard
                                    </h6>
                                    <InputText
                                        name="currentScoreCard"
                                        value={props.scoreCardName}
                                        disabled

                                        className="borderRadius"
                                    />
                                </div>

                                <div className="col-md-3">
                                    <h6
                                        style={{
                                            fontWeight: '600',
                                            fontSize: '16px',
                                        }}
                                    >
                                        New Scorecard
                                    </h6>
                                    <Dropdown
                                        name="newScoreCardId"
                                        filter
                                        value={newScoreCard}
                                        options={scoreCardsData?.data}
                                        onChange={(event) =>
                                            setNewScoreCard(
                                                event.target.value
                                            )
                                        }
                                        optionValue={'scorecard_id'}
                                        optionLabel={'scorecard_name'}
                                        placeholder="Select scorecard"
                                        className="custom-dropdown"
                                    // disabled={disableDisputeDetails}
                                    />
                                </div>

                                <div className="col-md-3 pe-0">
                                    <h6
                                        style={{
                                            fontWeight: '600',
                                            fontSize: '16px',
                                        }}
                                    >
                                        Inclusion
                                    </h6>
                                    <Dropdown
                                        name="scoreCardOverrideId"
                                        value={scoreCardOverride}
                                        options={
                                            scoreCardOverrideTypes?.data
                                        }
                                        onChange={(event) =>
                                            setScoreCardOverride(
                                                event.target.value
                                            )
                                        }
                                        optionValue={
                                            'scorecard_assign_override_type_id'
                                        }
                                        optionLabel={
                                            'scorecard_assign_override_type_name'
                                        }
                                        placeholder="Select Override"
                                        className="custom-dropdown"
                                    // disabled={disableDisputeDetails}
                                    />
                                </div>
                            </div>

                            <div className="row mt-4">
                                <div className="col-md-6">&nbsp;</div>
                                <div className="col-md-3 pe-0">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <Button className="btn-secondary">
                                                Cancel
                                            </Button>
                                        </div>
                                        <div className="col-md-6">
                                            <Button
                                                onClick={
                                                    submitProjectAssignOverride
                                                }
                                                className="btn-primary"
                                            >
                                                Apply
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    {scoreCardAssignOverrides !== null ? (
                        <div>
                            <div>
                                <DataTable
                                    className= "scorecardAssignmentTable"
                                    value={scoreCardAssignOverrides}
                                    rows={5}
                                    rowsPerPageOptions={[5, 10, 25, 50]}
                                    paginator={scoreCardAssignOverrides?.length > 5}
                                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                                    selection={selectedScorecards}
                                    onSelectionChange={(e) =>
                                        setSelectedScoreCards(e.value)
                                    }
                                    header={headerScorecard}
                                    emptyMessage="No customers found."
                                    globalFilterFields={[
                                        'name',
                                        'oracleID',
                                        'scorecard_name',
                                        'startdate',
                                        'expirationdate',
                                        'inclusion',
                                    ]}
                                    filters={filters}
                                    filterDisplay="menu"
                                    dataKey="id"
                                    selectionMode="checkbox"
                                >
                                    <Column selectionMode="multiple" />

                                    <Column
                                        header="Name"
                                        field="name"
                                        sortable
                                    />
                                    <Column
                                        header="OracleId"
                                        field="oracleID"
                                        sortable

                                    />
                                    <Column
                                        header="Scorecard"
                                        field="scorecard_name"
                                        sortable

                                    />
                                    <Column
                                        header="Start Date"
                                        field="startdate"
                                        filterField="startdate"
                                        body={(date) => DateTemplate(date?.startdate)}
                                        sortable

                                    />
                                    <Column
                                        header="Expiration Date"
                                        field="expirationdate"
                                        filterField="expirationdate"
                                        body={(date) => DateTemplate(date?.expirationdate)}
                                        sortable
                                    />
                                    <Column
                                        header="Status"
                                        field="inclusion"
                                    />
                                </DataTable>
                            </div>
                        </div>
                    ) : (
                        <div className="card mt-3 ms-1 me-1 shadow bg-body rounded border-0">
                            <div className="card-body p-0 pe-5 ps-4 align-middle text-center">
                                <div
                                    className="row"
                                    style={{ height: '15vh' }}
                                >
                                    <div
                                        className="col-md-12"
                                        style={{
                                            margin: 'auto',
                                            paddingTop: '10px',
                                        }}
                                    >
                                        <p className="align-middle">
                                            No results found, Try
                                            selecting an associate
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>

        </div>

    );
};
